<template>
  <div
    id="paymentAlert"
    :class="`${$mq}Mode`"
  >
    <el-alert
      type="warning"
      :closable="false"
      show-icon
      class="mainCard"
    >
      <div
        slot="title"
        class="title"
        :class="`${$mq}Mode`"
      >
        <el-row
          :gutter="2"
          type="flex"
        >
          <el-col
            :span="responsiveCol.one"
            class="textCol defaultCursor"
          >
            {{ $t('customAlert.payment.pleasePay') }}
          </el-col>
          <el-col
            :span="responsiveCol.two"
            class="buttonCol"
          >
            <el-button
              class="paymentButton"
              type="primary"
              round
              @click="openLink"
            >
              {{ $t('customAlert.payment.updatePayment') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-alert>
  </div>
</template>

<script>
export default {
  name: 'PaymentAlert',

  computed: {
    responsiveCol() {
      const col = {};
      if (this.$mq === 'mobile') {
        col.one = 24;
        col.two = 24;
      } else if (this.$mq === 'tablet') {
        col.one = 17;
        col.two = 7;
      } else {
        col.one = 19;
        col.two = 5;
      }
      return col;
    },
  },

  methods: {
    openLink() {
      let url = 'https://gcgroup-test.chargebeeportal.com/portal/v2/login?forward=home';
      if (process.env.VUE_APP_ENV === 'prod') {
        url = 'https://gcgroup.chargebeeportal.com/';
      }
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  #paymentAlert {
    .el-alert {
      background-color: #ECB6FF;
      color: #000;
      margin-bottom: 20px !important;
      display: flex;
      align-items: center;
      padding: 18px 16px;

      .paymentButton {
        word-break: break-word;
        white-space: normal;
      }

      .el-alert__content {
        .title {
          display: flex;
          justify-content: space-around;
          font-size: 14px;
          font-weight: normal;
          padding: 5px 0;
          line-height: 42px;

          .el-row {
            width: 100%;
          }

          span {
            align-self: center;
          }

          .textCol {
            line-height: 22px;
          }

          .buttonCol {
            text-align: right;

            .el-button {
              background: transparent;
              color: #000;
              border-color: #000;
              font-size: 14px;
              width: 100%;
              padding: 13px 0;
            }
          }

          &.tabletMode {
            line-height: 20px;
          }

          &.mobileMode {
            line-height: 20px;

            .el-row {
              flex-wrap: wrap;

              .el-col:first-child {
                margin-bottom: 10px;
              }
            }
          }
        }
      }
    }

    &.mobileMode {
      .el-alert {
        align-items: flex-start;
      }
    }
  }
</style>

<style lang="scss">
  #paymentAlert {
    .el-alert {
      .el-alert__icon {
        font-size: 28px;
        width: 28px;
      }

      .el-alert__content {
        width: 100%;
        padding-left: 20px;
      }
    }

    &.mobileMode {
      .el-alert {
        .el-alert__icon {
          padding: 10px 0 0;
        }
      }
    }
  }
</style>
